module.exports = __webpack_public_path__ + "23_bigdata_3.jpg?145c77101352920e864b119645575eb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_bigdata_3.jpg
// module id = 194
// module chunks = 0